import * as ActionTypes from '../actions/actionTypes';

const defaultState = {
  selectedProjects: [],
  projects: [],
  batchEdit: false,
};

const projects = (state = defaultState, action) => {
  switch (action.type) {
    case ActionTypes.PROJECTS_SELECT_ITEMS: {
      let newSelected = [...state.selectedProjects];
      const { projectId } = action.payload;
      const { batchEdit } = state;

      if (batchEdit) {
        const position = newSelected.findIndex(id => id === projectId);
        if (position > -1) {
          newSelected.splice(position, 1);
        } else {
          newSelected.push(projectId);
        }
      } else {
        newSelected = [projectId];
      }
      return { ...state, selectedProjects: newSelected };
    }
    case ActionTypes.PROJECTS_TOGGLE_BATCH_EDIT: {
      const { batchEdit, selectedProjects } = state;
      let newSelectedProjects = [...selectedProjects];
      if (selectedProjects.length > 0) {
        const lastItem = selectedProjects.pop();
        newSelectedProjects = [lastItem];
      }
      return { ...state, batchEdit: !batchEdit, selectedProjects: newSelectedProjects };
    }
    case ActionTypes.PROJECT_DESELECT_ALL: {
      return { ...state, selectedProjects: [] };
    }
    case ActionTypes.PROJECTS_ADD: {
      return { ...state };
    }
    default:
      return state;
  }
};

export default projects;



// WEBPACK FOOTER //
// ./src/redux/reducers/projects.js